import TableOrders from './TableOrders';

export default TableOrders;
